'use strict';
import React, { useRef, useState } from 'react';

import { get } from 'lodash';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import { FormattedMessage } from 'react-intl';
import ReservationInfo from './ReservationInfo';
import PinInput from '../../tag/PinInput';
import Alert from '../../Alert';
import { MATERNITY_ULTRA_KEY } from '../../../definitions/AppointmentConstants';

const { id: module_id } = module;

const ReservationOption = ({
  data,
  pinCodeIsValid,
  selectOption,
  validatePinCode,
  pinCodeError,
  appointmentError,
}) => {
  const pinInput = useRef(null);
  const [pin, setPin] = useState('');

  return (
    <li className={'appointment'} style={{ width: '100%' }}>
      <Row>
        <Span len="10" sm-len="12">
          <FormattedMessage id={data.key + '.location'} />
        </Span>
        <Controls
          data={data}
          isValid={pinCodeIsValid}
          error={pinCodeError}
          module_id={module_id}
          pinInput={pinInput}
          pin={pin}
          setPin={setPin}
          onSendPinClicked={() => validatePinCode(pin)}
          selectOption={selectOption}
          isMobile={false}
          appointmentError={appointmentError}
        />
      </Row>
      {get(data, 'meta', null) !== null && (
        <Row>
          <Span>
            <ReservationInfo data={data} />
          </Span>
        </Row>
      )}
    </li>
  );
};

const Controls = (props) => {
  const {
    data,
    isValid,
    error,
    module_id,
    pinInput,
    pin,
    setPin,
    onSendPinClicked,
    selectOption,
    isMobile,
    appointmentError,
  } = props;
  const { key, carePlanId } = data;

  // Show pin code only for maternity ultra reservation and only if the patient has no care plan.
  if (key === MATERNITY_ULTRA_KEY && !isValid && !carePlanId) {
    return (
      <div className="appointment__pincodeform">
        <span>
          <PinInput
            labelId={`${module_id}.label`}
            ref={pinInput}
            value={pin}
            onChange={(ev) => setPin(ev.target.value)}
            labelStyle={{ width: 80 }}
          />
          <button onClick={onSendPinClicked}>
            <FormattedMessage id="reserve.validatepin" />
          </button>
        </span>
        {error && <Alert message="reserve.invalidpin" />}
      </div>
    );
  }

  return (
    <button
      style={
        isMobile
          ? { width: '100%', marginTop: '10px' }
          : { marginLeft: '10px', float: 'right' }
      }
      className="appointment__button"
      onClick={() => selectOption(data.key)}
      disabled={key === MATERNITY_ULTRA_KEY && appointmentError}
    >
      <FormattedMessage id="reserve.appointment" />
    </button>
  );
};

export default ReservationOption;
